const translationStrings = {
  noResults: Drupal.t('No results.'),
  select: Drupal.t('Select ...'),
  contactPersons: {
    availableContacts: Drupal.t('Available contacts'),
    contact: Drupal.t('Contact persons'),
    getInTouch: Drupal.t('Get in touch'),
    modalClose: Drupal.t('Close modal'),
    modalTitle: Drupal.t('Contact via e-mail'),
    noResults: Drupal.t('No results, try another country.'),
    selectCountry: Drupal.t('Select your country'),
  },
  productsPortfolio: {
    linkMore: Drupal.t('Learn more about @category_name'),
    noResults: Drupal.t('No results, try another category.'),
  },
  productVersions: {
    closeModal: Drupal.t('Close modal'),
    generalProductInformation: Drupal.t('General product information'),
    noTechInfo: Drupal.t(
      'Selected version does not have any info about technical information.',
    ),
    switchVariationLabel: Drupal.t('Switch product version'),
  },
};

export default translationStrings;
